import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import AppContext from "../../appContext";

import * as api from "../../services";
import LibraryContext from "../libraryContext";
import useActiveContexts from "../useActiveContexts";

export default function useJoinGroup() {
  const { t } = useTranslation();
  const { handleQuery } = useContext(LibraryContext);
  const {
    app: {
      project: { id: projectId },
      sessionId,
    },
    dispatch,
  } = useContext(AppContext);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");

  const handleError = ({ value, message }) => {
    setIsError(value);
    setError(message);
  };

  // server state
  const { refetchContexts } = useActiveContexts();
  const addNewContextMutation = useMutation(
    (invitationCode) =>
      api.addContext({ invitationCode, projectId, sessionId }),
    {
      onSuccess: (data) => {
        if (data.data?.status > 0) {
          refetchContexts(); // update the active contexts
          dispatch({
            type: "UPDATE_CLIENTS",
            payload: new Date(),
          }); // trigger clients list to refresh
        } else {
          handleError({
            value: true,
            message: t("library.joinDialog.invalid"),
          });
        }
      },
    }
  );
  const rejoinContextMutation = useMutation(
    ({ id }) => api.setContextStatus({ id, left: 0, projectId, sessionId }),
    {
      onSuccess: (data, { contextId }) => {
        if (data.data?.status === 1) {
          refetchContexts(); // update the active contexts
          handleQuery({ type: "navContextClick", payload: contextId }); // jump to the contextId in the library
          dispatch({
            type: "UPDATE_CLIENTS",
            payload: new Date(),
          }); // trigger clients list to refresh
        } else {
          handleError({ value: true, message: "Can't rejoin the group" });
        }
      },
    }
  );

  return { addNewContextMutation, rejoinContextMutation, isError, error };
}
